import { render, staticRenderFns } from "./PersonnelRecordDeadlinesDataList.vue?vue&type=template&id=a5243730"
import script from "./PersonnelRecordDeadlinesDataList.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDeadlinesDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports